module.exports = __webpack_public_path__ + "static/media/Testing-Automation.cb160546.jpg";